
// this might not be needed -- thought it would be a cool feature to track the history
import { createBrowserHistory } from "history";

const history = createBrowserHistory();

export default history;
